/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-05 16:32:16
 * @LastEditTime: 2022-01-05 18:03:50
 * @LastEditors: zhao - 🍉
 * @Description: 银联资金清算记录 - 明细数据 
 * @FilePath: /zhzj-admin/src/page/TransferRecordLog/components/RecordLogInfoView.jsx
 */
import { Icon, Input, Table } from 'antd'
import React from 'react'

const TransferRecordLogInfo = (props) => {
    // 单个行修改
    const handleChange = (e, index, type) => {
       const value = props.value.map((row, rowIndex) => {
           if (rowIndex === index) {
               return {...row, [type]: e.target.value}
           }
           return row
       })
       props.onChange && props.onChange(value)
    }
    // 新增行
    const handleAdd = () => {
        const value = props.value.concat({})
        props.onChange && props.onChange(value)
    }
    // 删除行
    const handleDelete = (index) => {
        const value = props.value.filter((e,i) => index !== i)
        props.onChange && props.onChange(value)
    }
    const renderInput = (text,  index, type) => {
        return <Input size="small" value={text} onChange={(e) => handleChange(e, index, type )} />
    }
    const iconStyle = {
        fontSize: 22,
        color: '#999',
        cursor: 'pointer'
    }
    let columns = []
    if (props.instructionType  === 1) {
        columns = [
            { title: '收款单位', dataIndex: 'accountName', render: (text, record, index) => renderInput(text, index, 'accountName') },
            { title: '收款账号', dataIndex: 'accountNumber',render: (text, record, index) => renderInput(text,  index, 'accountNumber') },
            { title: '开户行', dataIndex: 'bankName', render: (text, record, index) => renderInput(text,  index, 'bankName') },
            { title: '开户行行号', dataIndex: 'bankNo', render: (text, record, index) => renderInput(text,  index, 'bankNo') },
            { title: '银联商户号', dataIndex: 'merchantNo', render: (text, record, index) => renderInput(text,  index, 'merchantNo') },
            { title: '金额', dataIndex: 'transferAmount', render: (text, record, index) => renderInput(text,  index, 'transferAmount') },
            { title: '删除', dataIndex: 'action', width: 46, render:(text, record, index) => {
                return <Icon type="minus-circle" style={iconStyle}  onClick={() => handleDelete(index)} />
            } }
        ]
    } else {
        columns = [
            { title: '银联商户号', dataIndex: 'merchantNo', render: (text, record, index) => renderInput(text,  index, 'merchantNo') },
            { title: '金额', dataIndex: 'transferAmount', render: (text, record, index) => renderInput(text,  index, 'transferAmount') },
            { title: '删除', dataIndex: 'action', width: 46, render:(text, record, index) => {
                return <Icon type="minus-circle" style={iconStyle}  onClick={() => handleDelete(index)} />
            } }
        ]
    }
   
   
    return (
        <div>
            <div style={{ textAlign: 'right', paddingRight:14 }}>
                <Icon type="plus-circle" style={iconStyle} onClick={handleAdd} />
            </div>
            <Table columns={columns} bordered pagination={false} dataSource={props.value} />
        </div>
    )
}

export default TransferRecordLogInfo


// WEBPACK FOOTER //
// ./src/page/TransferRecordLog/components/RecordLogInfoView.jsx